import Cards from './Cards/Cards';
import { ApiHubCardDataProvider } from '../../Contexts/ApiHubCardDataContext';



const ApiHub = () => {
  return (
    <div className="flex flex-col">
      <ApiHubCardDataProvider>
        <Cards />
        <div className='mt-3'>
          <iframe src="https://elk.devsuiteltts.com/app/dashboards#/view/e4449f5a-ebf5-4968-bafd-6d94383769d9?embed=true&_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A60000)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))&show-query-input=true&show-time-filter=true" height="600" width="100%" title='Dashboard'></iframe>
        </div>
      </ApiHubCardDataProvider>

    </div>
  );
};

export default ApiHub;

